import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import users from 'reducers/users';
import announcements from 'reducers/announcements';
import series from 'reducers/series';
import models from 'reducers/models';
import functionalGroups from 'reducers/functionalGroups';
import functionalOptionCodeMappings from 'reducers/functionalOptionCodeMappings';
import templates from 'reducers/templates';
import bodyStyles from 'reducers/bodyStyles';
import dashboard from 'reducers/dashboard';
import selectedSeriesId from 'reducers/selectedSeriesId';
import paints from 'reducers/paints';
import wheels from 'reducers/wheels';
import interiors from 'reducers/interiors';
import trims from 'reducers/trims';
import roofAndMirrorCaps from 'reducers/roofAndMirrorCaps';
import colorLines from 'reducers/colorLines';
import modelsWorkingState from 'reducers/modelsWorkingState';
import modelsViewer from 'reducers/modelsViewer';
import templatesWorkingState from 'reducers/templatesWorkingState';
import templatesSubmitted from 'reducers/templatesSubmitted';
import cart from 'reducers/cart';
import inCartFunctionalGroups from 'reducers/inCartFunctionalGroups';
import inCartModels from 'reducers/inCartModels';
import inCartTemplates from 'reducers/inCartTemplates';
import inCartSeries from 'reducers/inCartSeries';
import search from 'reducers/search';
import dataStatus from 'reducers/dataStatus';
import seriesPipeline from 'reducers/seriesPipeline';
import userSetting from 'reducers/userSetting';
import websockets from 'reducers/websockets';
import modelPipeline from 'reducers/modelPipeline';
import modelAdvanced from 'reducers/modelAdvanced';
import modelCompetition from 'reducers/modelCompetition';
import loading from 'reducers/loading';
import templateFilters from 'reducers/templateFilters';

const rootReducer = combineReducers({
  announcements,
  bodyStyles,
  cart,
  colorLines,
  dashboard,
  dataStatus,
  form,
  functionalGroups,
  functionalOptionCodeMappings,
  inCartFunctionalGroups,
  inCartModels,
  inCartSeries,
  inCartTemplates,
  interiors,
  loading,
  modelAdvanced,
  modelCompetition,
  modelPipeline,
  models,
  modelsViewer,
  modelsWorkingState,
  paints,
  roofAndMirrorCaps,
  search,
  selectedSeriesId,
  series,
  seriesPipeline,
  templates,
  templateFilters,
  templatesSubmitted,
  templatesWorkingState,
  trims,
  userSetting,
  users,
  websockets,
  wheels,
});

export default rootReducer;
